import ApplicationError from './system/ApplicationInitializationError';
import Config from './Config';
export default class ConfigProvider {
    static get config() {
        this.ensureInitialized();
        return this.$config;
    }
    static init(config) {
        const resolvedConfig = new Config(config);
        ConfigProvider.$config = resolvedConfig;
    }
    static ensureInitialized() {
        if (!this.$config) {
            throw new ApplicationError('TSUtils has not been initialized.');
        }
    }
}
//# sourceMappingURL=ConfigProvider.js.map